import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import { Redirect } from 'react-router'
import intl from 'react-intl-universal'
import object_value from '../api/object_value'
import Select from 'react-select'

// react-dates
import moment from 'moment'
import 'moment-timezone'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'

moment.locale('en')

@inject('user', 'cities', 'categories', 'experiencesSearch')
@observer
class Search extends Component {
  constructor (props, context) {
    super(props, context)

    const {user, cities, categories, experiencesSearch} = props

    cities.get()
    categories.get()
    experiencesSearch.request()

    this.state = {
      navigate: false
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    console.log('Search.js - handleSubmit()', event)
    const {experiencesSearch, redirect} = this.props
    experiencesSearch.request()

    const pathname = window.location.pathname
    if (redirect && pathname !== '/search') {
      await this.setState({navigate: true})
    }
  }

  handleInputChange = (event) => {
    console.log('Search.js - handleInputChange() - event.target', event.target)
    console.log('Search.js - handleInputChange() - event.value', event.value)
    const target = event.target

    let value = event.value
    if (target) {
      if (target.type === 'checkbox') {
        value = target.checkbox
      } else if (target.type === 'number' || target.type === 'radio') {
        value = parseInt(target.value)
      } else {
        value = target.value
      }
    }

    const name = target
      ? target.name
      : event.name

    console.log('handleInputChange()', name, value)

    const {experiencesSearch} = this.props
    experiencesSearch.set(name, value)
  }

  // Selects
  // TODO: Make one handler
  handleCityIdChange = ({label, value}) => {
    console.log('city_id', value, label)

    const {experiencesSearch} = this.props
    experiencesSearch.set('city_id', value)
  }
  handleChangeDate = (start_moment, end_moment) => {
    const {experiencesSearch} = this.props

    if (start_moment) {
      let start_date = start_moment.format('YYYY-MM-DD')
      experiencesSearch.set('start_date_moment', start_moment)
      experiencesSearch.set('start_date', start_date)
    }

    if (end_moment) {
      let end_date = end_moment.format('YYYY-MM-DD')
      experiencesSearch.set('end_date_moment', end_moment)
      experiencesSearch.set('end_date', end_date)
    }
  }
  handleCategoryIdChange = ({label, value}) => {
    console.log('category_id', value, label)

    const {experiencesSearch} = this.props
    experiencesSearch.set('category_id', value)
  }
  handleNumberGuestsChange = ({label, value}) => {
    console.log('number_guests', value, label)

    const {experiencesSearch} = this.props
    experiencesSearch.set('number_guests', value)
  }

  render () {
    const {
      experiencesSearch,
      type
    } = this.props
    const {query} = experiencesSearch

    // Redirect to results page
    // https://stackoverflow.com/a/43333330/8551889
    const { navigate } = this.state
    if (navigate) {
      return <Redirect to="/search" push={true} />
    }

    if (type === 'form') {
      return (
        <form className='b-form'
              onSubmit={this.handleSubmit}>

          <div className='b-form-row'>
            <div className='b-form-item'>
              <div className='b-form-item-wrapSelect'>
                <Select id='city_id'
                        name='city_id'
                        placeholder='All'
                        value={object_value(query, 'city_id', null)}
                        options={[
                          {value: null, label: 'Alle'},
                          ...this.props.cities.options
                        ]}
                        onChange={this.handleCityIdChange}
                        searchable={false} />
              </div>
              <label className='b-form-item-label'
                     htmlFor='city_id'>
                {intl.get('search.city')}
              </label>
            </div>
          </div>

          <div className='b-form-row'>
            <div className='b-form-item'>
              <div className='b-form-item-wrapSelect'>
                <Select id='category_id'
                        name='category_id'
                        placeholder='All'
                        value={object_value(query, 'category_id', null)}
                        options={[
                          {value: null, label: 'Alle'},
                          ...this.props.categories.options
                        ]}
                        onChange={this.handleCategoryIdChange}
                        searchable={false} />
              </div>
              <label className='b-form-item-label'
                     htmlFor='category_id'>
                {intl.get('search.category')}
              </label>
            </div>
          </div>

          <div className='b-form-row'>
            <div className='b-form-item'>
              <div className='b-form-item-DatePickerWrap filled'>
                <DateRangePicker
                  orientation='vertical'
                  withFullScreenPortal={true}
                  displayFormat='DD.MM.YYYY'
                  // defaultValue={this.state.date}
                  startDateId='startDate'
                  endDateId='endDate'
                  startDate={object_value(query, 'start_date_moment', null)} // momentPropTypes.momentObj or null
                  endDate={object_value(query, 'end_date_moment', null)} // momentPropTypes.momentObj or null
                  onDatesChange={({ startDate, endDate }) => this.handleChangeDate(startDate, endDate)} // PropTypes.func.isRequired
                  focusedInput={this.state.dates_focused} // PropTypes.bool
                  onFocusChange={(focusedInput) => this.setState({dates_focused: focusedInput})} // PropTypes.func.isRequired
                  firstDayOfWeek={1}
                  navPrev={<div className='b-form-item-DatePicker-arrow left' />}
                  navNext={<div className='b-form-item-DatePicker-arrow right' />}
                  hideKeyboardShortcutsPanel
                  readOnly
                  noBorder
                  // required
                />
              </div>
              <label className='b-form-item-label'
                     htmlFor='category_id'>
                {intl.get('search.date')}
              </label>
            </div>
          </div>

          <div className='b-form-row'>
            <button className='b-button b-button_primary b-button_x'>
              {intl.get('search.search')}
            </button>
          </div>
        </form>
      )
    }

    return (
      <div className='b-search-wrap'>
        <form className='b-search'
              onSubmit={this.handleSubmit}>

          <div className='b-search-item'>
            <div className='b-search-item-wrapSelect'>
              <Select id='city_id'
                      name='city_id'
                      placeholder='Alle'
                      value={object_value(query, 'city_id', null)}
                      options={[
                        {value: null, label: 'Alle'},
                        ...this.props.cities.options
                      ]}
                      onChange={this.handleCityIdChange}
                      searchable={false} />
            </div>
            <label className='b-search-item-label'
                   htmlFor='city_id'>
              {intl.get('search.city')}
            </label>
          </div>

          <div className='b-search-item'>
            <div className='b-search-item-wrapSelect'>
              <Select id='category_id'
                      name='category_id'
                      placeholder='Alle'
                      value={object_value(query, 'category_id', null)}
                      options={[
                        {value: null, label: 'Alle'},
                        ...this.props.categories.options
                      ]}
                      onChange={this.handleCategoryIdChange}
                      searchable={false} />
            </div>
            <label className='b-search-item-label'
                   htmlFor='category_id'>
              {intl.get('search.category')}
            </label>
          </div>

          <div className='b-search-item'>
            <div className='b-search-item-wrapSelect'>
              <div className='b-form-item-DatePickerWrap filled'>
                <DateRangePicker
                  displayFormat='DD.MM.YYYY'
                  // defaultValue={this.state.date}
                  startDateId='startDate'
                  endDateId='endDate'
                  startDate={object_value(query, 'start_date_moment', null)} // momentPropTypes.momentObj or null
                  endDate={object_value(query, 'end_date_moment', null)} // momentPropTypes.momentObj or null
                  onDatesChange={({ startDate, endDate }) => this.handleChangeDate(startDate, endDate)} // PropTypes.func.isRequired
                  focusedInput={this.state.dates_focused} // PropTypes.bool
                  onFocusChange={(focusedInput) => this.setState({dates_focused: focusedInput})} // PropTypes.func.isRequired
                  firstDayOfWeek={1}
                  navPrev={<div className='b-form-item-DatePicker-arrow left' />}
                  navNext={<div className='b-form-item-DatePicker-arrow right' />}
                  hideKeyboardShortcutsPanel
                  readOnly
                  noBorder
                  // required
                />
              </div>
            </div>
            <label className='b-search-item-label'
                   htmlFor='category_id'>
              {intl.get('search.date')}
            </label>
          </div>

          <div className='b-search-item'>
            <button className='b-button b-button_primary b-button_x'>
              {intl.get('search.search')}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

Search.defaultProps = {
  type: 'search',
  redirect: false
}

Search.propTypes = {
  type: PropTypes.string,
  redirect: PropTypes.bool,
  user: MobxPropTypes.observableObject,
  cities: MobxPropTypes.observableObject,
  categories: MobxPropTypes.observableObject,
  experiencesSearch: MobxPropTypes.observableObject
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search.js